import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// OQ ESTA ACONTECENDO: O código acima é a entrada principal do aplicativo React.
// Ele importa as bibliotecas necessárias, o componente App e o arquivo de estilo CSS. 
// Em seguida, ele cria uma raiz para o aplicativo usando ReactDOM e renderiza o componente App dentro do elemento com o ID 'root' no HTML. O React.StrictMode é usado para destacar problemas potenciais no aplicativo durante o desenvolvimento.